module.exports = __webpack_public_path__ + "static/media/Rect2.bf7a8cf0.svg";